import { useState } from 'react';
import useAuthForm from '../../../hooks/useAuthForm';
import { unlockAccount } from '../../../services/authService';
import validateByType from '../../../hooks/useFormValidation';

const useForgotPassword = () => {
  const initialValues = { email: '' };

  return useAuthForm({
    initialValues,
    validateFn: (form) => validateByType('unlockAccount', form),
    submitFn: unlockAccount,
    onSuccessNavigateTo: '/',
  });
};

export default useForgotPassword;
